import { Typography } from '@tunasong/ui-lib'
import { graphHooks } from '@tunasong/graph-lib/react'
import { entitySort, type FilterFunc, type SortOptions } from '@tunasong/models'
import type { AudioMedia, Persisted } from '@tunasong/schemas'
import { isAudio } from '@tunasong/schemas'
import type { FC, HTMLAttributes } from 'react'
import Waveform from './waveform.js'
import styles from './entity-audio-clips.module.css'

export interface EntityAudioClipsProps extends HTMLAttributes<HTMLDivElement> {
  parentId: string
  /** @default isAudio */
  filter?: FilterFunc
}

const sortOptions = { sortBy: 'updatedAt', order: 'desc' } satisfies SortOptions

export const EntityAudioClips: FC<EntityAudioClipsProps> = props => {
  const { parentId, filter = isAudio, ...restProps } = props
  const { entities: clips } = graphHooks.useEntityChildrenIncremental<Persisted<AudioMedia>>({ parentId, filter })
  const audioClips = entitySort({ entities: clips, sortOptions })

  return (
    <div {...restProps}>
      <div className={styles.list}>
        {audioClips.length > 0 ? (
          audioClips.map(clip => (
            <div className={styles.clipWrapper} key={clip.id}>
              <Waveform
                key={clip.id}
                media={clip}
                timeline={false}
                autoStop={true}
                className={styles.waveform}
                renderPeaks={true}
              />
            </div>
          ))
        ) : (
          <Typography variant="caption">No clips</Typography>
        )}
      </div>
    </div>
  )
}

export default EntityAudioClips
